module.exports = __webpack_public_path__ + "static/img/ext2.466a4901.jpg";